<template>
  <div id="other_status">
    <v-card class="mt-4">
      <v-toolbar color="primary h5" dark>{{ $t(item.title) }}</v-toolbar>
      <v-card-text
        class="custom-padding"
        v-if="Array.isArray(item.data) && item.data.length > 0"
      >
        <v-timeline>
          <v-timeline-item
            v-for="(status, i) in item.data"
            :key="i"
            color="primary"
            large
          >
            <template v-slot:opposite>
              <span> {{ dateFormatter(new Date(status.time * 1000)) }}</span>
            </template>
            <v-card>
              <!-- <v-card-title class="headline">
                {{ timelineLine(status.label) }}
                </v-card-title> -->
              <v-card-title class="headline pb-2">
                {{ status.label }}
              </v-card-title>
              <div v-if="status.user && !isClient" :class="['body-1 px-4 text--secondary',{'pb-4':(status.user && !isClient) && !status.note}]" style="font-style: italic;">By: {{ status.user }}</div>
              <v-card-text v-if="status.note">
                {{ timelineLine(status.note) }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-text v-else
        ><div class="w-100 text-center second-text">
          {{ $t("no_data") }}
        </div></v-card-text
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PopUpTimeLine",
  props: ["item"],
  methods: {
    timelineLine(text) {
      if (text == null || text === "") {
        return "";
      }
      const key = String(text);
      return this.$te(key) ? this.$t(key) : text;
    },
    dateFormatter(date) {
      let d = date;
      return (
        [
          d.getHours() > 9 ? d.getHours() : `0${d.getHours()}`,
          d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`,
          // d.getSeconds() > 9 ? d.getSeconds() : `0${d.getSeconds()}`,
        ].join(":") +
        " " +
        [
          d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`,
          d.getMonth() + 1 > 9 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`,
          d.getFullYear(),
        ].join("-")
      );
    },
  },
  computed: {
    isClient: function () {
      return this.$store.getters.currentUser.data.is_client;
    },
  },
};
</script>

<style scoped>
.custom-padding {
  padding-inline-start: 15% !important;
  padding-inline-end: 15% !important;
}
</style>
